
export const getKaohaoInfo = (answerSheet, positionData) => {
    if (!positionData?.length) return []
    const type = answerSheet.acCardStudentCodeType

    // 收集所有页面的 basicInfo
    const basicInfos = positionData
        .filter(p => p.basicInfo)
        .map(p => p.basicInfo)

    if (type == 0) {
        // 涂点模式：遍历所有页面的 tiantuInfo
        const tiantuResults = []
        basicInfos.forEach(bi => {
            if (!bi.tiantuInfo) return
            const { tiantuInfo } = bi

            const itemPos = tiantuInfo.children
                .filter(col => col?.children?.length)
                .map(col =>
                    col.children.map(child =>
                        `${Math.round(child.x)},${Math.round(child.y)},${Math.round(child.w)},${Math.round(child.h)}`
                    ).join(';')
                )

            tiantuResults.push({
                item_pos: [{
                    page_index: tiantuInfo.pageindex || 0,
                    pos: itemPos
                }],
                region_pos: [[
                    tiantuInfo.pageindex || 0,
                    Math.round(tiantuInfo.x),
                    Math.round(tiantuInfo.y),
                    Math.round(tiantuInfo.w),
                    Math.round(tiantuInfo.h)
                ]],
                type: type,
                objForm: {
                    kaohaoType: 1,
                    sortType: 2,
                    kaohaoLen: answerSheet.acCardExamNumber,
                    kaohaoStyle: 1
                }
            })
        })
        return tiantuResults

    } else if (type == 1) {
        // 条形码模式：遍历所有页面的 codeInfo
        const codeResults = []
        basicInfos.forEach(bi => {
            if (!bi.codeInfo) return
            const { codeInfo } = bi

            codeResults.push({
                item_pos: [{
                    page_index: codeInfo.pageIndex || 0
                }],
                region_pos: [[
                    codeInfo.pageindex || 0,
                    Math.round(codeInfo.x),
                    Math.round(codeInfo.y),
                    Math.round(codeInfo.w),
                    Math.round(codeInfo.h)
                ]],
                type: 2 // 类型校正为条形码
            })
        })
        return codeResults

    } else if (type == 2) {
        // 手写模式：遍历所有页面的 kaohaoInfo
        const kaohaoResults = []
        basicInfos.forEach(bi => {
            if (!bi.kaohaoInfo) return
            const { kaohaoInfo } = bi

            kaohaoInfo.children
                .filter(item => item.name === '姓名' || item.name === '考号')
                .forEach(item => {
                    kaohaoResults.push({
                        item_pos: [{
                            page_index: kaohaoInfo.pageindex || 0
                        }],
                        region_pos: [
                            [
                                kaohaoInfo.pageindex || 0,
                                Math.round(item.x),
                                Math.round(item.y),
                                Math.round(item.w),
                                Math.round(item.h)
                            ]
                        ],
                        type: item.name === '姓名' ? 3 : 4,
                        objForm: {
                            kaohaoType: 4,
                            sortType: 2,
                            kaohaoLen: answerSheet.acCardExamNumber,
                            kaohaoStyle: 1
                        }
                    })
                })
        })
        return kaohaoResults
    }

    return []
}
//客观题
export const getObjectiveInfo = (acCardQuestTh) => {
    const pageMap = new Map();

    // 1. 获取所有页面容器（确保无嵌套）
    const hasPageWrap = document.querySelectorAll('.page-wrap').length > 0;
    const pageContainers = Array.from(hasPageWrap
        ? document.querySelectorAll('.page-wrap')
        : document.querySelectorAll('.page-cell:not(.red-card)')
    );

    // 2. 遍历每个页面容器
    pageContainers.forEach((pageContainer, pageIndex) => {

        const pageRect = pageContainer.getBoundingClientRect();
        const pageData = {
            page_index: pageIndex,
            region_pos: [],
            obj_item: [],
            area_info: []
            //region_info: []
        };

        // 3. 获取当前页内的所有客观题内容块
        const objectiveContents = Array.from(
            pageContainer.querySelectorAll('.objective-content')
        );

        // 4. 处理每个内容块



        objectiveContents.forEach((objectiveContent) => {
            const objectiveArea = Array.from(
                objectiveContent.querySelectorAll('.obj-group')
            );

            const dataTh = objectiveContent.getAttribute('data-th');


            const objEl = objectiveContent.querySelector('.obj-cont');
            const areaRect = objEl.getBoundingClientRect();

            // 区域坐标
            pageData.area_info.push([
                pageData.area_info.length, // 区域索引
                Math.round(areaRect.left - pageRect.left),
                Math.round(areaRect.top - pageRect.top),
                Math.round(areaRect.width),
                Math.round(areaRect.height)
            ]);

            for (let index = 0; index < objectiveArea.length; index++) {
                const _elArea = objectiveArea[index];
                const contentRect = _elArea.getBoundingClientRect();
                // 区域坐标
                pageData.region_pos.push([
                    pageData.region_pos.length, // 区域索引
                    Math.round(contentRect.left - pageRect.left),
                    Math.round(contentRect.top - pageRect.top),
                    Math.round(contentRect.width),
                    Math.round(contentRect.height)
                ]);

                _elArea.querySelectorAll('.group').forEach((group) => {
                    let groItems = Array.from(group.querySelectorAll('.gro-item .value'));
                    //是否是旧版
                    let isOld = 0;
                    if (groItems.length === 0) {
                        isOld = 1;
                        groItems = Array.from(group.querySelectorAll('.gro-item'));
                    }

                    const tihaoItem = groItems.shift();
                    const tihaoRect = tihaoItem.getBoundingClientRect();

                    pageData.obj_item.push({
                        index: pageData.region_pos.length - 1,
                        page_index: pageIndex,
                        item_pos: groItems.map(item => {
                            const rect = item.getBoundingClientRect();
                            if (isOld) {
                                //旧版
                                // 旧版：所有值减少3px
                                const adjust = (value) => Math.max(Math.round(value) - 3, 0); // 确保不小于0
                                return [
                                    rect.left - pageRect.left,
                                    rect.top - pageRect.top + 3,
                                    adjust(rect.width) - 6,
                                    adjust(rect.height)
                                ].join(',');
                            } else {
                                return [
                                    Math.round(rect.left - pageRect.left),
                                    Math.round(rect.top - pageRect.top) + 1,
                                    rect.width,
                                    rect.height
                                ].join(',');
                            }
                        }).join(';'),
                        key: `${chineseToNumber(dataTh)}.${tihaoItem.textContent.trim()}`,
                        tihao: {
                            value: tihaoItem.textContent.trim(),
                            pos: [
                                Math.round(tihaoRect.left - pageRect.left),
                                Math.round(tihaoRect.top - pageRect.top)
                            ]
                        }
                    });

                });

            }
            // const objEl = objectiveContent.querySelector('.obj-cont');
            // const contentRect = objEl.getBoundingClientRect();

            // // 区域坐标
            // pageData.region_pos.push([
            //     pageData.region_pos.length, // 区域索引
            //     Math.round(contentRect.left - pageRect.left),
            //     Math.round(contentRect.top - pageRect.top),
            //     Math.round(contentRect.width),
            //     Math.round(contentRect.height)
            // ]);

            // 题目项
            // objectiveContent

            // 区域信息
            // if (questData) {
            //     pageData.region_info.push({
            //         policy: 1,
            //         sortType: 1,
            //         tiNums: questData.quest_list.length,
            //         bigNum: dataTh,
            //         bTihao: questData.quest_list[0]?.quest_sechth || '',
            //         queKeys: questData.quest_list.map(q => q.quest_sechth),
            //         queNames: Array.from(objectiveContent.querySelectorAll('.group'))
            //             .map(g => g.querySelector('.gro-item').textContent.trim())
            //     });
            // }
        });

        // 仅当有数据时存入
        if (pageData.region_pos.length > 0) {
            pageMap.set(pageIndex, pageData);
        }
    });
    return Array.from(pageMap.values()).sort((a, b) => a.page_index - b.page_index);
}


//特征区域
export const getLocalRegionInfo = (answerSheet) => {

    const pages = document.querySelectorAll('.page-cell:not(.red-card)');
    const rows = document.querySelectorAll('.preview_wrapper_row');
    const result = [];

    pages.forEach((page, pageIndex) => {
        // 获取答题卡标题区域
        const nameEl = page.querySelector('.card-title');
        if (nameEl) {
            const nameRect = nameEl.getBoundingClientRect();
            const pageRect = page.getBoundingClientRect();
            result.push([
                pageIndex,
                Math.round(nameRect.left - pageRect.left), // x
                Math.round(nameRect.top - pageRect.top),   // y
                Math.round(nameRect.width),                // w
                Math.round(nameRect.height)               // h
            ].join(','));
        }

        // 获取禁止作答区域
        const row = rows[pageIndex];
        if (row) {

            const textEl = row.querySelector('.position_remind_value');
            if (textEl && window.getComputedStyle(textEl).display !== 'none') {
                const textRect = textEl.getBoundingClientRect();
                const rowRect = row.getBoundingClientRect();
                result.push([
                    pageIndex,
                    Math.round(textRect.left - rowRect.left),
                    Math.round(textRect.top - rowRect.top),
                    Math.round(textRect.width),
                    Math.round(textRect.height)
                ].join(','));
            }
        }
    });

    return result;
};

//四角定位
export const getPositionPoints = () => {
    const pageWraps = document.querySelectorAll('.page-wrap');
    const pageCells = document.querySelectorAll('.page-cell:not(.red-card)');
    const hasPageWrap = pageWraps.length > 0;
    const validCells = Array.from(pageCells).filter(cell =>
        !cell.classList.contains('red-card')
    );
    const points = [];
    let globalPageIndex = 0;

    const getCoords = (element, parent) => ({
        x: Math.round(element.getBoundingClientRect().left - parent.getBoundingClientRect().left),
        y: Math.round(element.getBoundingClientRect().top - parent.getBoundingClientRect().top),
        w: Math.round(element.getBoundingClientRect().width),
        h: Math.round(element.getBoundingClientRect().height)
    });
    if (hasPageWrap) {
        pageWraps.forEach(wrap => {
            const cells = wrap.querySelectorAll('.page-cell');
            cells.forEach(cell => {
                const hasPositionPoint = cell.querySelector('.position_point');
                if (!hasPositionPoint) return;

                const positionMap = {
                    left: cell.querySelector('.position_point.left'),
                    right: cell.querySelector('.position_point.right'),
                    top: cell.querySelector('.position_point.top'),
                    bottom: cell.querySelector('.position_point.bottom')
                };

                Object.entries(positionMap).forEach(([pos, el]) => {
                    if (el) {
                        const coords = getCoords(el, wrap);
                        points.push({
                            pageIndex: globalPageIndex,
                            posType: pos,
                            ...coords
                        });
                    }
                });
            });
            globalPageIndex++;
        });
    } else {
        validCells.forEach(cell => {
            const hasPositionPoint = cell.querySelector('.position_point');
            if (!hasPositionPoint) return;

            ['left', 'right', 'top', 'bottom'].forEach(pos => {
                const point = cell.querySelector(`.position_point.${pos}`);
                if (point) {
                    const coords = getCoords(point, cell);
                    points.push({
                        pageIndex: globalPageIndex,
                        posType: pos,
                        ...coords
                    });
                }
            });
            globalPageIndex++;
        });
    }

    const sortedPoints = points.sort((a, b) => {
        const posOrder = { left: 0, top: 1, right: 2, bottom: 3 };
        return a.pageIndex - b.pageIndex || posOrder[a.posType] - posOrder[b.posType];
    });

    const uniqueMap = new Map();
    const uniquePoints = [];
    sortedPoints.forEach(p => {

        const coordKey = `${p.pageIndex}|${p.posType}|${p.x}|${p.y}|${p.w}|${p.h}`;
        if (!uniqueMap.has(coordKey)) {
            uniqueMap.set(coordKey, true);
            uniquePoints.push(p);
        }
    });

    return uniquePoints.map(p => [p.pageIndex, p.x, p.y, p.w, p.h]);
};

// 客观题区域
export const getSubjectiveInfo = (acCardQuestTh, answerSheet) => {

    const hasPageWrap = document.querySelectorAll('.page-wrap').length > 0;
    const pages = Array.from(hasPageWrap
        ? document.querySelectorAll('.page-wrap')
        : document.querySelectorAll('.page-cell:not(.red-card)')
    );
    const pageContainers = Array.from(pages).filter(cell =>
        !cell.classList.contains('red-card') // 排除旧元素
    );

    let output = {
        box: [], // 存储所有大框数据
        items: [] // 存储所有小题数据
    };

    // 预处理填空题数据（排除红卡内的大框）
    const fillWarps = pageContainers.flatMap(page =>
        Array.from(page.querySelectorAll('.fill-warp'))
            .filter(cont => !cont.closest('.red-card'))
    );

    // 按 data-th 分组
    const groupedFillWarps = fillWarps.reduce((acc, warp) => {
        const th = warp.getAttribute('data-th');
        if (th) {
            acc[th] = acc[th] || [];
            acc[th].push(warp);
        }
        return acc;
    }, {});

    // 处理每个分组
    Object.entries(groupedFillWarps).forEach(([chineseTh, warps]) => {
        const key = chineseToNumber(chineseTh); // 转换为数字题号（如 1）
        const boxEntry = {
            key: key,
            pos: [] // 存储大框跨页的位置信息
        };
        const items = [];

        // 遍历当前分组的所有大框
        warps.forEach(warp => {
            // 获取所在页面的索引和坐标
            const pageIndex = getPageIndex(pages, warp);
            const pageRect = pages[pageIndex].getBoundingClientRect();
            const warpRect = warp.getBoundingClientRect();

            // 记录大框位置
            boxEntry.pos.push([
                pageIndex,
                Math.round(warpRect.left - pageRect.left),
                Math.round(warpRect.top - pageRect.top),
                Math.round(warpRect.width),
                Math.round(warpRect.height)
            ]);

            // 处理大框内的子题项
            warp.querySelectorAll('.row').forEach(row => {
                Array.from(row.querySelectorAll('.str-th')).forEach(th => {
                    const thNumber = th.textContent.match(/\d+/)?.[0];
                    if (!thNumber) {
                        console.warn('题号格式异常:', th.textContent);
                        return;
                    }

                    // 查找对应的填空项
                    let fillItem = th.nextElementSibling;
                    while (fillItem && !fillItem.classList.contains('fill-item')) {
                        fillItem = fillItem.nextElementSibling;
                    }
                    if (!fillItem) return;

                    // 构造完整题号（如 1.1）
                    const fullSechth = `${key}.${thNumber}`;

                    // 计算小题位置
                    const itemRect = fillItem.getBoundingClientRect();
                    items.push({
                        key: fullSechth,
                        pos: [ // 保持数组格式，便于后续处理
                            pageIndex,
                            Math.round(itemRect.left - pageRect.left),
                            Math.round(itemRect.top - pageRect.top),
                            Math.round(itemRect.width),
                            Math.round(itemRect.height)
                        ]
                    });
                });
            });
        });

        output.box.push(boxEntry);
        output.items.push(...items);
    });

    // 解答题区域
    // 解答题
    // 解答题类型（questTh_type==3）

    // 获取所有解答题容器并按data-th分组
    //const answerConts = Array.from(document.querySelectorAll('.answer-cont'));
    const answerConts = pageContainers.flatMap(page =>
        Array.from(page.querySelectorAll('.answer-cont'))
            .filter(cont => !cont.closest('.red-card'))
    );

    const groupedAnswers = answerConts.reduce((acc, el) => {
        const key = el.getAttribute('data-th');
        if (key) {
            acc[key] = acc[key] || [];
            acc[key].push(el);
        }
        return acc;
    }, {});

    // 处理每个分组
    Object.entries(groupedAnswers).forEach(([fullTh, elements]) => {

        const items = [];
        // 处理每个区域的坐标
        elements.forEach(el => {
            const pageIndex = getPageIndex(pages, el);
            const pageRect = pages[pageIndex].getBoundingClientRect();
            const elRect = el.getBoundingClientRect();

            // 区域坐标
            items.push({
                key: fullTh,
                pos: [ // 保持数组格式，便于后续处理
                    pageIndex,
                    Math.round(elRect.left - pageRect.left),
                    Math.round(elRect.top - pageRect.top),
                    Math.round(elRect.width),
                    Math.round(elRect.height)
                ]
            });
        });

        output.items.push(...items);
    });



    // 作文题区域
    // 语文作文题 questTh_type=5
    const writeCNQuestions = acCardQuestTh.find(th => th.questTh_type === 5);
    const thKey = writeCNQuestions?.quest_list?.[0]?.quest_sechth;


    // 提前查询所有.warp元素，避免重复查询
    const allWarps = document.querySelectorAll('.write-wrap');

    const containerSelector = hasPageWrap ? '.page-wrap' : '.page-cell:not(.red-card)';

    allWarps.forEach(warp => {
        const items = [];
        const container = warp.closest(containerSelector);
        if (!container) return;

        const pageIndex = pageContainers.indexOf(container);
        if (pageIndex === -1) return;

        const containerRect = container.getBoundingClientRect();
        const warpRect = warp.getBoundingClientRect();

        // 为每个.warp创建区域信息
        items.push({
            key: thKey,
            pos: [[
                pageIndex,
                Math.round(warpRect.left - containerRect.left),
                Math.round(warpRect.top - containerRect.top),
                Math.round(warpRect.width),
                Math.round(warpRect.height)
            ]],
        });

        output.items.push(...items);
    });

    // 英语作文题
    const writeENQuestions = acCardQuestTh.find(th => th.questTh_type === 5);
    const thENKey = writeENQuestions?.quest_list?.[0]?.quest_sechth;


    // 提前查询所有.warp元素，避免重复查询
    const allENWarps = document.querySelectorAll('.write-wrap-en');
    const containerSelectorEN = hasPageWrap ? '.page-wrap' : '.page-cell:not(.red-card)';

    allENWarps?.forEach(warp => {
        const items = [];
        const container = warp.closest(containerSelectorEN);
        if (!container) return;

        const pageIndex = pageContainers.indexOf(container);
        if (pageIndex === -1) return;

        const containerRect = container.getBoundingClientRect();
        const warpRect = warp.getBoundingClientRect();

        // 为每个.warp创建区域信息
        items.push({
            key: thENKey,
            pos: [[
                pageIndex,
                Math.round(warpRect.left - containerRect.left),
                Math.round(warpRect.top - containerRect.top),
                Math.round(warpRect.width),
                Math.round(warpRect.height)
            ]]
        });

        output.items.push(...items);
    });

    return output;
}

// 获取评分区域
// 
export const getScoreBoxPositions = () => {
    const hasPageWrap = document.querySelectorAll('.page-wrap').length > 0;
    const pageContainers = Array.from(hasPageWrap
        ? document.querySelectorAll('.page-wrap')
        : document.querySelectorAll('.page-cell:not(.red-card)')
    );
    let score = [];
    //如果有 .score-box 则为整体打分，否则为单个题打分
    const validSelector = `.score-box:not(.score-df)`;
    const scoreBoxes = Array.from(document.querySelectorAll(validSelector))

    scoreBoxes.map((box, index) => {
        const container = box.closest(hasPageWrap ? '.page-wrap' : '.page-cell:not(.red-card)');
        const dataTh = box.getAttribute('data-th');
        if (!container) return null;

        const pageIndex = pageContainers.indexOf(container);

        const boxRect = box.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();

        score.push({
            key: dataTh,
            index: index,
            pos: [
                pageIndex,
                Math.round(boxRect.left - containerRect.left),
                Math.round(boxRect.top - containerRect.top),
                Math.round(boxRect.width),
                Math.round(boxRect.height)
            ]
        });
    }).filter(Boolean);

    //填空题的每题打分模式
    const fillDF = Array.from(document.querySelectorAll('.fill-item input'));

    fillDF.map((box, index) => {
        const container = box.closest(hasPageWrap ? '.page-wrap' : '.page-cell:not(.red-card)');
        const fillwarp = box.closest('.fill-warp');
        const dataTh = fillwarp.getAttribute('data-th');
        // 获取小题
        const fillTh = box.closest('.row').querySelector('.str-th');
        let key = '';
        if (fillTh) {
            const thValue = parseInt(fillTh.textContent.match(/\d+/)[0], 10);
            key = chineseToNumber(dataTh) + '.' + thValue
        } else {
            key = chineseToNumber(dataTh)
        }

        if (!container) return null;

        const pageIndex = pageContainers.indexOf(container);

        const boxRect = box.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();

        score.push({
            key: key,
            index: index,
            pos: [
                pageIndex,
                Math.round(boxRect.left - containerRect.left),
                Math.round(boxRect.top - containerRect.top),
                Math.round(boxRect.width),
                Math.round(boxRect.height)
            ]
        });
    }).filter(Boolean);

    return score;

};
// 获取打分区域
export const getScoreDFPositions = () => {
    const hasPageWrap = document.querySelectorAll('.page-wrap').length > 0;
    const pageContainers = Array.from(hasPageWrap
        ? document.querySelectorAll('.page-wrap')
        : document.querySelectorAll('.page-cell:not(.red-card)')
    );

    const result = [];

    document.querySelectorAll('.score-df').forEach(scoreBox => {
        const containerEl = scoreBox.closest(hasPageWrap ? '.page-wrap' : '.page-cell:not(.red-card)');
        if (!containerEl) return;

        const pageIndex = pageContainers.indexOf(containerEl);

        const allCells = [...scoreBox.querySelectorAll('.score-cell')];
        const dataTh = scoreBox.getAttribute('data-th');
        const areaEntries = allCells.map((cell, index) => {
            const rawValue = cell.textContent.trim();
            if (!rawValue) return null;

            // 区域类型判断
            let type;
            if (index >= 0 && index <= 7) {         // 十位区
                type = 1;
            } else if (index >= 9 && index <= 18) { // 个位区
                type = 2;
            } else if (index >= 20 && index <= 21) {// 小数区
                type = 3;
            } else {
                return null; // 非计分区域
            }

            // 数值处理
            let value = parseFloat(rawValue);
            if (type === 1) value = value * 10; // 十位数值放大

            // 坐标计算（相对容器）
            const cellRect = cell.getBoundingClientRect();
            const containerRect = containerEl.getBoundingClientRect();
            return {
                pageIndex,
                type,
                value: Number(value.toFixed(1)),
                pos: [
                    Math.round(cellRect.left - containerRect.left),
                    Math.round(cellRect.top - containerRect.top),
                    Math.round(cellRect.width),
                    Math.round(cellRect.height)
                ]
            };
        }).filter(Boolean); // 过滤空值

        result.push({
            key: dataTh,
            area: areaEntries
        });
    });

    return result;
};

// 获取学生信息区域
export const getStuInfoReactions = () => {
    const hasPageWrap = document.querySelectorAll('.page-wrap').length > 0;
    const pageContainers = Array.from(hasPageWrap
        ? document.querySelectorAll('.page-wrap')
        : document.querySelectorAll('.page-cell:not(.red-card)')
    );
    let stu_info = [];
    document.querySelectorAll('.basics').forEach((warp, index) => {
        const container = warp.closest(hasPageWrap ? '.page-wrap' : '.page-cell');
        if (!container) return;

        const pageIndex = pageContainers.indexOf(container);
        if (pageIndex === -1) return;

        const containerRect = container.getBoundingClientRect();
        const warpRect = warp.getBoundingClientRect();

        // 为每个.warp创建区域信息
        stu_info.push([
            pageIndex,
            Math.round(warpRect.left - containerRect.left),
            Math.round(warpRect.top - containerRect.top),
            Math.round(warpRect.width),
            Math.round(warpRect.height),
        ]);
    })
    return stu_info;

};
//缺考信息
export const getQuekao = () => {
    const hasPageWrap = document.querySelectorAll('.page-wrap').length > 0;
    const pageContainers = Array.from(hasPageWrap
        ? document.querySelectorAll('.page-wrap')
        : document.querySelectorAll('.page-cell:not(.red-card)')
    );

    let quekao = [];
    document.querySelectorAll('.c-b').forEach(warp => {
        const container = warp.closest(hasPageWrap ? '.page-wrap' : '.page-cell');
        if (!container) {
            console.warn('元素未找到页面容器:', warp);
            return;
        }

        const pageIndex = pageContainers.indexOf(container);
        if (pageIndex === -1) return;

        const containerRect = container.getBoundingClientRect();
        const elementRect = warp.getBoundingClientRect();

        // 计算相对坐标并取整
        quekao.push([
            pageIndex,
            Math.round(elementRect.left - containerRect.left),
            Math.round(elementRect.top - containerRect.top),
            Math.round(elementRect.width),
            Math.round(elementRect.height)
        ]);
    });
    return quekao;
}
//纸张尺寸
export const getSize = () => {
    const hasPageWrap = document.querySelectorAll('.page-wrap').length > 0;
    const pageContainers = Array.from(hasPageWrap
        ? document.querySelectorAll('.page-wrap')
        : document.querySelectorAll('.page-cell:not(.red-card)')
    );
    let size = [];
    pageContainers.forEach((container, index) => {
        const containerRect = container.getBoundingClientRect();
        size.push(`${Math.round(containerRect.width)}, ${Math.round(containerRect.height)}`);
    })
    return size;
}
function getOptionsString(num) {
    return Array.from({ length: num }, (_, i) => String.fromCharCode(65 + i)).join('');
}
// 获取页面坐标
function getPageRect(pageIndex) {
    const pages = [...document.querySelectorAll('.page-wrap, .page-cell')];
    return pages[pageIndex]?.getBoundingClientRect() || new DOMRect(0, 0, 0, 0);
}

function getPageIndex(pages, element) {
    let current = element.parentElement;
    while (current) {
        const index = pages.findIndex(page => page === current);
        if (index > -1) return index;
        current = current.parentElement;
    }
    return 0;
}
function groupByDataTh(elements) {
    return elements.reduce((acc, el) => {
        const key = el.getAttribute('data-th');
        if (key) {
            acc[key] = acc[key] || [];
            acc[key].push(el);
        }
        return acc;
    }, {});
}

// 阿拉伯数字转中文数字（适用于题号）
function chineseToNumber(chinese) {
    const digitMap = {
        '零': 0, '一': 1, '二': 2, '三': 3, '四': 4,
        '五': 5, '六': 6, '七': 7, '八': 8, '九': 9
    };
    const unitMap = {
        '十': 10,
        '百': 100,
        '千': 1000
    };

    let result = 0;
    let temp = 0;
    let unit = 1;

    for (let i = chinese.length - 1; i >= 0; i--) {
        const char = chinese[i];

        if (digitMap[char] !== undefined) {
            temp = digitMap[char];
            result += temp * unit;
        } else if (unitMap[char] !== undefined) {
            unit = unitMap[char];
            if (temp === 0) result += 1 * unit;  // e.g. "十二" = "一十二"
        }
    }

    return result;
}